import { render } from "./Board.vue?vue&type=template&id=195e5a4c&scoped=true"
import script from "./Board.vue?vue&type=script&lang=js"
export * from "./Board.vue?vue&type=script&lang=js"

import "./Board.vue?vue&type=style&index=0&id=195e5a4c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-195e5a4c"

export default script